import { Component, input, output } from '@angular/core';
import { CapitalButton } from "@commons/capital-button/capital-button";
import { PrimaryButton } from "@commons/primary-button/primary-button";

@Component({
  selector: 'app-agile-login-instructions',
  imports: [CapitalButton, PrimaryButton],
  templateUrl: './instructions.html',
  styleUrl: './instructions.scss',
})
export class Instructions {
  click = output<void>();
  disabled = input(false);
}
